const WPVUE = window.WPVUE

export default {
	singupModalOpen: (state) => state.singupModalOpen,
	getCurrentRoute: (state) => state.route,
	servicesLoaded: (state) => state.servicesLoaded,
	getServices: (state) => state.postsData.service,
	isDarkMode: (state) => state.isDarkMode,
	newsletterModalOpen: (state) => state.newsletterModalOpen,
	getMarkets: (state) => state.postsData.marketing,
	marketsLoaded: (state) => state.marketsLoaded,
	isFrontPage: (state, getters) =>
		getters.currentPage && Number(getters.currentPageID) === Number(WPVUE.pages.front.id),
	isArchive: (state) =>
		state.route.meta && state.route.meta.type && state.route.meta.type === 'archive' ? true : false,
	searchModalOpen: (state) => state.searchModalOpen,
	mainNaviIsOpen: (state) => state.mainNaviIsOpen,
	searchValue: (state) => state.searchValue,
	getOptions: (state) => state.options,
	featuredImage: (state, getters) =>
		getters.currentPage && getters.currentPage.featured_image ? getters.currentPage.featured_image : false,
	currentPostType: (state) => (state.route.meta && state.route.meta.post_type ? state.route.meta.post_type : 'page'),
	currentPageID: (state, getters) => {
		let pageID = getters.currentPage ? getters.currentPage.id : null
		//const postType = getters.currentPostType;
		//if (!pageID && postType) pageID = archivePageId(postType)
		return pageID ? Number(pageID) : null
	},
	pageTheme: (state, getters) => {
		let acf = getters.currentPage ? getters.currentPage.acf : null
		if (getters.currentPage && getters.currentPage.type === 'events') {
			return acf && acf.category ? acf.category : null
		} else {
			return acf && acf.template_color ? acf.template_color : null
		}
		//const postType = getters.currentPostType;
		//if (!pageID && postType) pageID = archivePageId(postType)
	},

	currentPage: (state, getters) => {
		let page = {}

		const router = getters.getCurrentRoute
		let postType = router.meta.type === 'archive' ? 'page' : getters.currentPostType
		//get revision
		if (router && router.query && router.query.preview === 'true' && router.query.nonce && router.query.post_id) {
			postType = 'revision'
			let pageToFind = Number(router.query.post_id)

			if (state.postsData && postType) {
				page = state.postsData[postType] ? state.postsData[postType].find((it) => pageToFind === it.parent) : {}
			}
		} else {
			if (state.postsData && postType) {
				const pagePath = state.route.path
				const homeLink = WPVUE.home.replace(/\/$/, '')
				const currentPageLink = pagePath.replace(/\/$/, '')

				let pageToFind = null
				switch (router.name) {
					case 'frontPage':
						pageToFind = Number(router.meta.id)
						page = state.postsData[postType]
							? state.postsData[postType].find((it) => pageToFind === it.id)
							: {}
						break

					default:
						page = state.postsData[postType]
							? state.postsData[postType].find((it) => {
									const itlink = it.link.replace(/\/$/, '').replace(homeLink, '')
									return itlink === currentPageLink
							  })
							: {}
						break
				}
			}
		}

		return page
	},
	/**
	 *
	 */
	storedTaxonomy:
		(state) =>
		(taxName = 'category', taxId) => {
			let taxonomy = []
			if (state.taxonomies && state.taxonomies[taxName] && state.taxonomies[taxName].length) {
				if (taxId) taxonomy = state.taxonomies[taxName].find((el) => Number(el.id) === Number(taxId))
				else taxonomy = state.taxonomies[taxName]
			}
			if (taxonomy && taxonomy.length) {
				taxonomy = taxonomy.map((e) => {
					const NewName = e.name
						.replace(/&amp;/g, '&')
						.replace(/&gt;/g, '>')
						.replace(/&lt;/g, '<')
						.replace(/&quot;/g, '"')
					return { ...e, name: NewName }
				})
			}
			return taxonomy
		},

	/**
	 * @param  {string} taxName='category'
	 * @param  {mixed-> array or string} slug=''
	 */
	storedTaxonomyBySlug:
		(state) =>
		(taxName = 'category', slug = '') => {
			let taxonomy = []
			if (!slug) return taxonomy
			if (state.taxonomies && state.taxonomies[taxName] && state.taxonomies[taxName].length) {
				if (Array.isArray(slug)) {
					taxonomy = slug.map((sl) => state.taxonomies[taxName].find((el) => el.slug === sl))
				} else {
					taxonomy = state.taxonomies[taxName].find((el) => el.slug === slug)
				}
			}

			return taxonomy
		},
	getMenu: (state) => (location) => {
		let menu = []
		if (location && state.menus && state.menus[location]) {
			menu = state.menus[location]
		}
		return menu
	},
}
